import React, { useState } from "react";

import { SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { ProjectSwiper, ProjectThumbnail } from "./styles";

const ProjectSlider = ({ image, images }) => {
      const [thumbsSwiper, setThumbsSwiper] = useState(null);

      return (
            <>
                  <ProjectSwiper
                        style={{
                              "--swiper-navigation-color": "#fff",
                              "--swiper-pagination-color": "#fff",
                        }}
                        spaceBetween={10}
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="mySwiper2"
                  >
                        {image && (
                              <SwiperSlide>
                                    <img src={image} />
                              </SwiperSlide>
                        )}
                        {images?.length > 0 &&
                              images?.map((item, index) => (
                                    <SwiperSlide key={index}>
                                          <img src={item.image} />
                                    </SwiperSlide>
                              ))}
                  </ProjectSwiper>
                  <ProjectThumbnail
                        onSwiper={setThumbsSwiper}
                        spaceBetween={10}
                        slidesPerView={4}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="mySwiper"
                  >
                        {image && (
                              <SwiperSlide>
                                    <img src={image} />
                              </SwiperSlide>
                        )}
                        {images?.length > 0 &&
                              images?.map((item, index) => (
                                    <SwiperSlide key={index}>
                                          <img src={item.image} />
                                    </SwiperSlide>
                              ))}
                  </ProjectThumbnail>
            </>
      );
};

export default ProjectSlider;
